import VerificationPageRetryablePartnerFlowContent from '@tenant/components/VerificationPageRetryablePartnerFlowContent';
import { VerificationStatus } from 'src/common/models/verificationModels';
import { FC, useEffect } from 'react';
import { useVerificationId } from 'src/common/hooks/useVerificationId';
import { useRedirectUrlQuery } from 'src/pages/VerificationPage/verificationQueries';
import {
  getRedirectUrlForStatus,
  handleRedirect,
} from 'src/common/services/process';
import { isNil } from 'ramda';
import { RetryVerificationProcessModal } from 'src/pages/VerificationPage/components/RetryVerificationProcessModal';

export type VerificationPageRetryablePartnerFlowProps = {
  verificationStatus?: VerificationStatus;
};

export const VerificationPageRetryablePartnerFlow: FC<
  VerificationPageRetryablePartnerFlowProps
> = ({ verificationStatus }) => {
  const id = useVerificationId();
  const { data, isLoading } = useRedirectUrlQuery(id);

  useEffect(() => {
    if (isNil(verificationStatus) || isLoading || !data) {
      return;
    }

    if (
      [
        VerificationStatus.Done,
        VerificationStatus.Failed,
        VerificationStatus.Expired,
      ].includes(verificationStatus)
    ) {
      handleRedirect(getRedirectUrlForStatus(verificationStatus, data));
    }
  }, [verificationStatus]);

  return (
    <>
      <RetryVerificationProcessModal verificationStatus={verificationStatus} />
      <VerificationPageRetryablePartnerFlowContent />
    </>
  );
};
